import PropTypes from 'prop-types'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../stories/atoms/button/constants'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import { Settings } from '../stories/atoms/icons/core'
import {
  HeaderButtons,
  HeaderButtonsLeft,
  HeaderButtonsRight,
  TileImage
} from './styled-component'
import ButtonComponent from '../stories/atoms/button'
import { ROLES } from '../../containers/TeamsManagement/constants'
import CheckboxComponent from '../stories/atoms/checkboxes'
import { checkboxSizeOptions } from '../stories/atoms/checkboxes/constants'
import { iconSizeOptions } from '../stories/atoms/icons/icons-sizes'
import { Confirm } from '../stories/atoms/icons/essentials'

export const TileCardHeaderButtons = ({
  item,
  roleName = null,
  contextMenu = null,
  disabled,
  hasCheckbox = false,
  isSelected = false,
  setIsSelected = () => {},
  onOpenSettings = null
}) => {
  const canSeeUserSettings = roleName === ROLES.POWERUSER && !!onOpenSettings

  const handleOpenSettings = (e) => {
    e.stopPropagation()
    onOpenSettings(item)
  }

  // the card itself is clickable, so its controls must swallow their own clicks.
  // The checkbox needs it twice over: besides the click on the control, it emits
  // a bubbling click from a hidden input on every change, which reaches the card
  // as a click on the tile
  const stopPropagation = (e) => e.stopPropagation()

  return (
    <HeaderButtons>
      <HeaderButtonsLeft onClick={stopPropagation}>
        {hasCheckbox && (
          <CheckboxComponent.Root
            size={checkboxSizeOptions.MEDIUM}
            checked={isSelected}
            disabled={disabled}
            onCheckedChange={setIsSelected}
          >
            <CheckboxComponent.Indicator>
              <Confirm size={iconSizeOptions['ICON-S']} />
            </CheckboxComponent.Indicator>
          </CheckboxComponent.Root>
        )}
      </HeaderButtonsLeft>

      <HeaderButtonsRight>
        {canSeeUserSettings && (
          <ButtonComponent
            buttonType={buttonTypeOptions['ICON-ONLY']}
            variant={buttonVariantOptions['IMAGE-OVERLAY']}
            size={buttonSizeOptions.SMALL}
            onClick={handleOpenSettings}
          >
            <Settings stroke={colorsOptions.greys.white} />
          </ButtonComponent>
        )}

        {contextMenu}
      </HeaderButtonsRight>
    </HeaderButtons>
  )
}

TileCardHeaderButtons.propTypes = {
  item: PropTypes.object,
  roleName: PropTypes.string,
  contextMenu: PropTypes.node,
  disabled: PropTypes.bool,
  hasCheckbox: PropTypes.bool,
  isSelected: PropTypes.bool,
  setIsSelected: PropTypes.func,
  onOpenSettings: PropTypes.func
}

const TileCardHeader = ({
  image,
  item,
  roleName = null,
  contextMenu = null,
  disabled,
  hasCheckbox = false,
  isSelected = false,
  setIsSelected = () => {},
  onOpenSettings = null
}) => {
  const { title } = item || { title: null }

  return (
    <TileImage background={image} alt={title} disabled={disabled}>
      <TileCardHeaderButtons
        item={item}
        roleName={roleName}
        contextMenu={contextMenu}
        disabled={disabled}
        hasCheckbox={hasCheckbox}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        onOpenSettings={onOpenSettings}
      />
    </TileImage>
  )
}

TileCardHeader.propTypes = {
  image: PropTypes.string,
  item: PropTypes.object,
  roleName: PropTypes.string,
  contextMenu: PropTypes.node,
  disabled: PropTypes.bool,
  hasCheckbox: PropTypes.bool,
  isSelected: PropTypes.bool,
  setIsSelected: PropTypes.func,
  onOpenSettings: PropTypes.func
}

export default TileCardHeader
